export const LANDING_PAGE_BASE_PATH = '/landing-page';

export const pageRoutes = {
  LANDING_PAGE: LANDING_PAGE_BASE_PATH,
  PICKER_PAGE: '/global-picker',
};

export const PROFILE_PAGE = '/profile';
